import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { breakpoints, colors, fonts, spacing } from '../../utils/styles';

const ProductSpecsRoot = styled(`div`)`
  padding: 0 ${spacing.md}px;

  @media (min-width: ${breakpoints.tablet}px) {
    padding: ${spacing['2xl']}px ${spacing.xl}px 0;
  }
`;

const Name = styled(`h1`)`
  color: ${colors.brandDark};
  font-family: ${fonts.heading};
  font-size: 1.8rem;
  font-weight: 500;
  margin: 0;
`;

const Description = styled(`p`)`
  color: ${colors.text};
  font-size: 1rem;
  line-height: 1.5;
`;

const Price = styled(`div`)`
  color: ${colors.brand};
  font-size: 1.8rem;
  font-weight: 500;
  letter-spacing: -0.02em;

  span {
    color: ${colors.textLight};
  }
`;

const ProductSpecs = props => {
  const {
    product: {
      title,
      description,
      variants: [variant]
    }
  } = props;

  const { price } = variant;

  return (
    <ProductSpecsRoot>
      <Name>{title}</Name>
      {/* {description.split("\\n").map((item, i) => {
        console.log(description.split('\n').length)
        return <Description key={i}>{item}</Description>
      })} */}
      <Description>
        {description}
        <br />
        <br />
        These stickers are printed on durable, high opacity adhesive vinyl which
        makes them perfect for regular use, as well as for covering other
        stickers or paint. The high-quality vinyl ensures there are no bubbles
        when applying the stickers.
        <br />
        <br />
        • High opacity film that’s impossible to see through
        <br /> • Fast and easy bubble-free application
        <br /> • Durable vinyl, perfect for indoor use
        <br /> • 95µ density
        <br />
        <br /> Don't forget to clean the surface before applying the sticker.
      </Description>
      <Price>
        <span>USD</span> ${price}
      </Price>
    </ProductSpecsRoot>
  );
};

ProductSpecs.propTypes = {
  product: PropTypes.object.isRequired
};

export default ProductSpecs;
